import React from 'react';
import ReactLoading from 'react-loading';

const SpinLoader = ({ isLoading, size, color }) => {
    size ? size = size : size = '16px';
    color ? color = color : color = '#cccccc  ';
    
    return (
        <div className='loader-container'>
            {isLoading && <ReactLoading type={'spin'} className='loader' height={size} width={size} color={color} />}
        </div>
    );
};

export default SpinLoader;
